import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import * as actionCreators from "../../../action/index.js";
import { updateAlertMessage } from "../../../helpers/common/helperConstant.js";

class DiscountPopUp extends React.Component {
  render() {
    return (
      <Modal
        centered
        show={this.props.showDiscountExpire}
        dialogClassName="new-alert-modal react-modal"
        backdrop="static"
        keyboard={false}
        onHide={this.props.handleClose}
      >
        <button
          className="close"
          onClick={() => this.props.resetDiscountNew()}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Body>
          <h5 className="modal-title">Alert</h5>
          <div className={`row NoMfgExsist mb-5`}>
            <div className="col-12">
              <p>Our offers have expired!<br/>Need assistance? Contact us at {this.props.const_var.crmSetting.phone_number}</p>
            </div>
          </div>
          <div className='alert-footer'>
              <button
                onClick={() => this.props.resetDiscountNew()} 
                className="btn btn-primary"
              >
                <span className="text">
                    Ok
                </span>
              </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStoreToProps = (state) => state.reducer;

export default connect(mapStoreToProps, actionCreators)(DiscountPopUp);
